var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"root"}},[_vm._v("\n    Hi there from Vue Component\n    "),_c('div',{attrs:{"id":"textZone"}},[_c('input',{attrs:{"type":"text","id":"textInput"}})])])
}]

export { render, staticRenderFns }